:global(#lead-enclosure) {
    margin-top: 20px;
    background-color: #fff;
}

.container {
    background-color: var(--sidebar-primary);
}
